import { useTranslation } from "react-i18next";
import { setLocale } from "../lib/i18n";
import { PageStub } from "../components/ui/PageStub";

export function Settings() {
  const { t, i18n } = useTranslation();
  return (
    <PageStub title={t("settings.title")}>
      <div className="flex flex-col gap-4 w-full max-w-xs">
        <div>
          <p className="text-xs opacity-70 mb-2">{t("settings.language")}</p>
          <div className="grid grid-cols-2 gap-2">
            {(["ja", "en"] as const).map((lng) => (
              <button
                key={lng}
                onClick={() => setLocale(lng)}
                className={`px-4 py-2 rounded-lg border ${
                  i18n.language === lng
                    ? "border-[var(--color-gold)] bg-[var(--color-shu)]/20"
                    : "border-[var(--color-gold)]/30"
                }`}
              >
                {lng === "ja" ? "日本語" : "English"}
              </button>
            ))}
          </div>
        </div>
        <p className="text-[10px] opacity-40 mt-8">
          {t("settings.version", { v: "0.0.1" })}
        </p>
      </div>
    </PageStub>
  );
}
